import { render, staticRenderFns } from "./CreateTag.vue?vue&type=template&id=5f147210"
import script from "./CreateTag.vue?vue&type=script&lang=js"
export * from "./CreateTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f147210')) {
      api.createRecord('5f147210', component.options)
    } else {
      api.reload('5f147210', component.options)
    }
    module.hot.accept("./CreateTag.vue?vue&type=template&id=5f147210", function () {
      api.rerender('5f147210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TagList/Modals/CreateTag.vue"
export default component.exports